import { Component, OnInit } from '@angular/core';
import { ApisService } from '@core/services/apis.service';

@Component({
  selector: 'app-monetization-terms',
  templateUrl: './monetization-terms.component.html',
  styleUrls: ['./monetization-terms.component.scss'],
})
export class MonetizationTermsComponent implements OnInit {
  loading = false;
  saving = false;

  items: any[] = [];
  activeId: number | null = null;

  form: any = {
    id: null,
    version: '',
    title_ar: '',
    title_en: '',
    content_ar: '',
    content_en: '',
  };

  constructor(private apis: ApisService) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.apis.getDashboardMonetizationTerms().subscribe({
      next: (res: any) => {
        const data = res?.data;
        this.items = data?.data || data || [];
        const active = Array.isArray(this.items) ? this.items.find((x) => x?.is_active) : null;
        this.activeId = active?.id ?? null;

        if (active) {
          this.setForm(active);
        } else if (Array.isArray(this.items) && this.items.length > 0) {
          this.setForm(this.items[0]);
        }

        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }

  setForm(item: any): void {
    this.form = {
      id: item?.id ?? null,
      version: item?.version ?? '',
      title_ar: item?.title_ar ?? '',
      title_en: item?.title_en ?? '',
      content_ar: item?.content_ar ?? '',
      content_en: item?.content_en ?? '',
    };
  }

  newTerms(): void {
    this.form = {
      id: null,
      version: '',
      title_ar: '',
      title_en: '',
      content_ar: '',
      content_en: '',
    };
  }

  save(): void {
    this.saving = true;
    const payload = {
      version: this.form.version,
      title_ar: this.form.title_ar,
      title_en: this.form.title_en,
      content_ar: this.form.content_ar,
      content_en: this.form.content_en,
    };

    const req$ = this.form.id
      ? this.apis.updateDashboardMonetizationTerms(this.form.id, payload)
      : this.apis.createDashboardMonetizationTerms(payload);

    req$.subscribe({
      next: () => {
        this.saving = false;
        this.load();
      },
      error: () => {
        this.saving = false;
      },
    });
  }

  activate(): void {
    if (!this.form.id) return;
    this.saving = true;
    this.apis.activateDashboardMonetizationTerms(this.form.id).subscribe({
      next: () => {
        this.saving = false;
        this.load();
      },
      error: () => {
        this.saving = false;
      },
    });
  }
}
